import Image from "next/image";
import React from "react";
import { broHeadshot } from "~/test-utility/test-data/test-headshots";
import { Body, Headline, Link } from "~/ui-library";
import { ClampedText } from "~/ui-library/components/ClampedText/ClampedText";
import { NextSeoProps } from "next-seo";
import { StructureDataProps } from "~/types/asgard/StructuredData";
import { BuildHTML } from "../BuildHtml/BuildHtml";

export type AuthorHeroProps = {
  headshotImageUrl: string | null;
  authorName: string;
  authorTitle: string;
  authorEmail: string;
  authorBioHTML: string | null;
};

export type AuthorHeroWithSEOProps = AuthorHeroProps & {
  seo: NextSeoProps;
  structuredData: StructureDataProps;
};

export const AuthorHero: React.FC<AuthorHeroProps> = ({
  headshotImageUrl,
  authorName,
  authorTitle,
  authorEmail,
  authorBioHTML,
}) => (
  <>
    <div className="bg-primary-50 px-s py-m md:px-m md:py-l lg:w-full lg:pb-[6rem] lg:pt-xl">
      <div className="lg:mx-[auto] lg:max-w-[848px]">
        <div className="flex">
          <div className="size-[7rem] shrink-0 md:size-[9rem]">
            <Image
              fill
              className="!relative size-[7rem] md:size-[9rem]"
              src={headshotImageUrl || broHeadshot}
              alt={authorName}
            />
          </div>
          <div className="pl-s md:pl-m">
            <Headline level={1} as="h1">
              {authorName}
            </Headline>
            <Body className="pt-s" size="large" bold>
              {authorTitle}
            </Body>
            <Link className="block pt-xs" href={`mailto:${authorEmail}`}>
              {authorEmail}
            </Link>
            {authorBioHTML ? (
              <ClampedText className="hidden max-h-[69rem] pt-xs md:block">
                <BuildHTML html={authorBioHTML} />
              </ClampedText>
            ) : null}
          </div>
        </div>
        {authorBioHTML ? (
          <ClampedText className="pt-s md:hidden">
            <BuildHTML html={authorBioHTML} />
          </ClampedText>
        ) : null}{" "}
      </div>
    </div>
  </>
);
